import React from 'react'

export interface IField {
    validate(callback: { (res: boolean): any }, focus?: boolean): any;
    setError?(errorText?: string, callback?: { (): any }): void;
    isDisabled?(): boolean; // Optional method
}

export function validateFields(callback: { (res: boolean): any }, ...fields: IField[]): void {
  validateFieldsEx(true, callback, ...fields)
}

export function validateFieldsEx(focus: boolean, callback: { (res: boolean): any }, ...fields: IField[]): void {
  if (!fields || fields.length == 0) {
    callback && callback(true)
    return
  }

  let valid = true
  let current = 0

  const validateNext = () => {
    while (current < fields.length && (!fields[current] || (fields[current].isDisabled && fields[current].isDisabled()))) {
      ++current
    }

    if (current < fields.length) {
      if (fields[current]) {
        fields[current].validate(onValidated, focus || false)
      }
    } else {
      callback && callback(valid)
      valid = null
      current = null
    }
  }

  var onValidated = (res: boolean) => {
    if (!res && valid) {
      valid = res
      focus = false
    }

    ++current

    setTimeout(() => {
      validateNext()
    }, 1)
  }

  validateNext()
}

export interface IFieldProps {
    label: string | JSX.Element
    requiredMessage?: string
    minLengthMessage?: string
    minLength?: number
    maxLengthMessage?: string
    maxLength?: number
}

export function getRequiredError(props: Readonly<IFieldProps>): string {
  let errorText = props.requiredMessage
  if (!errorText) {
    errorText = 'This field is required'
  }
  return errorText
}

export function getMinLengthError(props: Readonly<IFieldProps>, minLengthOverride?:number): string {
  let errorText = props.minLengthMessage
  if (!errorText) {
    errorText = `This field must have minimum length of ${minLengthOverride ?? props.minLength} characters`
  }
  return errorText
}

export function getMaxLengthError(props: Readonly<IFieldProps>): string {
  let errorText = props.maxLengthMessage
  if (!errorText) {
    errorText = `This field has excceded the maximum length of ${props.maxLength} characters`
  }
  return errorText
}
